// Admin API — Wallet Packages CRUD.
//
// Backed by `backend/routes/admin_wallet_packages.py`. All endpoints
// require `is_admin=true` — the shared axios instance in `./client`
// already attaches the JWT bearer.
import api from './client';

/** List every package (active + inactive), sorted by sort_order. */
export const adminListWalletPackages = async () => {
  const r = await api.get('/admin/wallet/packages');
  return r.data;
};

/** Create a new wallet package. */
export const adminCreateWalletPackage = async (payload) => {
  const r = await api.post('/admin/wallet/packages', payload);
  return r.data;
};

/** Partial-update an existing package. */
export const adminUpdateWalletPackage = async (id, patch) => {
  const r = await api.put(`/admin/wallet/packages/${id}`, patch);
  return r.data;
};

/** Hard-delete a package. */
export const adminDeleteWalletPackage = async (id) => {
  const r = await api.delete(`/admin/wallet/packages/${id}`);
  return r.data;
};

/** Bulk-reorder via `sort_order`. `items` = [{id, sort_order}]. */
export const adminReorderWalletPackages = async (items) => {
  const r = await api.post('/admin/wallet/packages/reorder', { items });
  return r.data;
};
